import React, { useEffect, useState } from 'react'
import ConsultasComunes from '../Sql/ConsultasComunes.js';
import MsgUtils from '../Tools/MsgUtils.js';
import Modal from 'react-bootstrap/Modal';

function ItemSucursalInventario(props) {
    const { info, fecha, tipo, regional, actualizar, setActualizar } = props;
    const [error, setError] = useState({});
    const [datos, setDatos] = useState(null);
    const [loading, setLoadin] = useState(false);
    const [editarDatos, setEditarDatos] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [observaciones, setObservaciones] = useState('');

    const getInformacion = async () => {
        try {
            setLoadin(true);
            var infologin = JSON.parse(localStorage.getItem('info'))
            var resultado = await ConsultasComunes.getInventarioSucursal({ regional, 'SUCURSAL': info, tipo, fecha, 'ID_EMPLEADO': infologin.ID_EMPLEADO });
            if (resultado.ok) {
                setLoadin(false);
                if (resultado.ok.length != 0) {
                    setDatos(resultado.ok[0]);
                } else {
                    setDatos(null);
                }
            } else {
                setDatos(null);
                setLoadin(false);
                setError({ 'error': resultado.error });
            }
        } catch (error) {
            setDatos(null)
            setLoadin(false);
            setError({ 'error': error.message });
        }
    }
    const validarInventario = async (estado) => {
        try {
            setLoadin(true);
            var infologin = JSON.parse(localStorage.getItem('info'))
            var resultado = await ConsultasComunes.setEstadoInventarioSucursal(
                { regional, 'SUCURSAL': info, 'ESTADO': estado, 'ID_EMPLEADO': infologin.ID_EMPLEADO, 'ID_INVENTARIO': datos.ID_INVENTARIO });
            if (resultado.ok) {
                setLoadin(false);
                setError({});
                setActualizar(!actualizar);
                MsgUtils.msgCorrecto(resultado.ok);
            } else {
                setLoadin(false);
                setError({ 'error': resultado.error });
                MsgUtils.msgError("Error " + resultado.error);
            }
        } catch (error) {
            setLoadin(false);
            setError({ 'error': error.message });
        }
    }
    const guardarInformacion = async () => {
        if (observaciones != '') {
            var lista = document.querySelectorAll(`#${info.SUCURSAL.replace(/ /g, "") }producto`);
            var idProductos = datos.DETALLE.map((item) => item.ID_PRODUCTO);
            var cont = 0;
            var datosModificados = []
            for (var valores of lista) {
                if (valores.value != '') {
                    datosModificados.push({ 'ID_PRODUCTO': idProductos[cont], 'CANTIDAD': valores.value });
                }
                cont += 1;
            }
            console.log(datosModificados)
            try {
                setLoadin(true);
                var infologin = JSON.parse(localStorage.getItem('info'))
                var resultado = await ConsultasComunes.guardarInventarioIniSucursal(
                    {
                        regional, 'SUCURSAL': info, 'ID_EMPLEADO': infologin.ID_EMPLEADO,
                        'ID_INVENTARIO': datos.ID_INVENTARIO, 'DATOS': datosModificados,
                        'OBSERVACIONES': observaciones
                    });
                if (resultado.ok) {
                    setEditarDatos(false);
                    setLoadin(false);
                    setError({});
                    setActualizar(!actualizar);
                    MsgUtils.msgCorrecto(resultado.ok);
                } else {
                    setLoadin(false);
                    setError({ 'error': resultado.error });
                    MsgUtils.msgError("Error " + resultado.error);
                }
            } catch (error) {
                setLoadin(false);
                setError({ 'error': error.message });
            }
        }else{
            MsgUtils.msgError("Es necesario colocar las observaciones")
        }
    }
    useEffect(() => {
        console.log(props);
        if (fecha != '') {
            getInformacion()
        }
    }, [actualizar])
    return (
        <div>
            {datos != null && <div className='row row-cols gx-1'>
                <div className='col text-light'>
                    <div>Almacen :{datos.NOMBRE_ALMACEN}</div>
                    <div>Validado por :{datos.NOMBRE_VALIDADO}</div>
                </div>
                {editarDatos == false && <div className='col'>
                    {datos.ESTADO == null &&
                        <div className='row row-cols g-1'>
                            <div className='col'><button className='btn btn-sm w-100 btn-secondary' onClick={() => validarInventario('P')}>VALIDAR PARCIAL</button></div>
                            <div className='col'><button className='btn btn-sm w-100 btn-success' onClick={() => validarInventario('V')}>VALIDAR</button></div>
                        </div>}
                    {datos.ESTADO == 'P' &&
                        <button className='btn btn-sm w-100 btn-success' onClick={() => validarInventario('V')}>VALIDAR</button>}
                    {datos.ESTADO == 'V' &&
                        <button className='btn btn-sm w-100 btnNaranja d-none' onClick={() => validarInventario('')}>DESVALIDAR</button>}
                </div>}
                <div className='col' style={{ minWidth: '50px', maxWidth: '200px' }}>
                    <div className='btn-group btn-group-sm'>
                        {editarDatos == false && <button className='btn btn-warning btn-sm'
                            title='Editar Datos'
                            onClick={() => { datos.ESTADO != 'V' ? setEditarDatos(true) : MsgUtils.msgError("No se permite modificar los validados") }}><i className="fa-solid fa-pen-to-square"></i></button>}
                        {editarDatos == true && <button className='btn btn-danger btn-sm'
                            title='Cancelar edicion de datos'
                            onClick={() => setEditarDatos(false)}
                        ><i className="fa-solid fa-xmark"></i>Cancelar</button>}
                        {editarDatos == true && <button className='btn btn-success btn-sm mx-1'
                            title='Guardar Cambios de los datos'
                            onClick={() => setShowModal(true)}
                        ><i className="fa-solid fa-floppy-disk"></i> Guardar</button>}
                    </div>
                </div>
            </div>}
            {datos != null && datos.DETALLE.length != 0 && <div className='table-responsive' style={{ height: '300px' }}>
                <table className="table table-dark table-sm table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">DESCRIPCION</th>
                            <th scope="col">CANTIDAD</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.DETALLE.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <th scope="row">{item.ID_PRODUCTO}</th>
                                    <td>{item.DESCRIPCION}</td>
                                    {editarDatos == false && <td>{item.CANTIDAD + ' [' + item.SIMBOLO + ']'}</td>}
                                    {editarDatos == true && <td>
                                        <input id={`${info.SUCURSAL.replace(/ /g, "")}producto`} type='number'
                                            //disabled={(item.ID_PRODUCTO==187 || item.ID_PRODUCTO==920)?true:false}
                                            className='form-control form-control-sm'
                                            placeholder={item.CANTIDAD}
                                        ></input>
                                    </td>}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>}
            {loading == true && <div className='bg-warning text-light fa-fade'>Espere Por favor ...</div>}
            {error.error != undefined && <div className='bg-danger text-light'>{error.error}</div>}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                backdrop="static"
                keyboard={false}
                centered
                contentClassName='bg-dark bg-gradient text-light'>
                <Modal.Header closeButton>
                    <Modal.Title>Registrar Incidencia</Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <div className='container-fluid'>
                        <div className="mb-1">
                            <label className="form-label">Observaciones</label>
                            <textarea className="form-control"
                                placeholder="Escriba Aqui"
                                value={observaciones}
                                onChange={(e) => setObservaciones(e.target.value)}
                                style={{ height: "140px" }}>
                            </textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-sm btn-danger' onClick={() => setShowModal(false)}>CANCELAR</button>
                    <button className='btn btn-sm btn-success' onClick={() => guardarInformacion()}>GUARDAR</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ItemSucursalInventario